import React, { FC, SyntheticEvent, useState } from "react";
import Navbar from "../../common/Navbar/Navbar";
import Layout from "../../common/layouts/Layout";
import { Box, Container, Tabs, Tab } from "@mui/material";
import { a11yProps } from "../../../utils/helper";
import TabPanel from "../../common/TabPanel/TabPanel";
import InitialReview from "./InitialReviewTab/InitialReview";
import AdditionalDocument from "./AdditionalDocumentTab/AdditionalDocument";
import ECNotification from "./ECNotificationTab/ECNotification";
import ECAnnualReport from "./ECAnnualReportTab/ECAnnualReport";
import PvpdDetails from "./PVPDDetailsTab/PvpdDetails";
import SaeTab from "./SAETab/SaeTab";
import StudyClose from "./StudyCloseTab/StudyClose";

const stepsInfo = ["1. Study Details", "2. EC Submission"];
const EthicsCommittee: FC = (props) => {
  const [ECSubmissionTabValue, setECSubmissionTabValue] = useState(0);
  const handleECSubmissionTabChange = (
    event: SyntheticEvent,
    newValue: any
  ) => {
    setECSubmissionTabValue(newValue);
  };
  return (
    <>
      <Layout>
        <>
          <Navbar pageTitle="New EC Submission" />
          <Container maxWidth={false}>
            <div>
              <Box className={`custom-tabs`}>
                <Tabs
                  value={ECSubmissionTabValue}
                  onChange={handleECSubmissionTabChange}
                  aria-label="tabs"
                >
                  <Tab label="Initial Review" {...a11yProps(0)} />
                  <Tab label="Additional Document" {...a11yProps(1)} />
                  <Tab label="EC Notification" {...a11yProps(2)} />
                  <Tab label="EC Annual Report" {...a11yProps(3)} />
                  <Tab label="PV/PD EC notifications" {...a11yProps(4)} />
                  <Tab label="SAE" {...a11yProps(5)} />
                  <Tab label="Study Close Out Report" {...a11yProps(6)} />
                </Tabs>
                <TabPanel value={ECSubmissionTabValue} index={0}>
                  <InitialReview value={ECSubmissionTabValue} />
                </TabPanel>
                <TabPanel value={ECSubmissionTabValue} index={1}>
                  <AdditionalDocument value={ECSubmissionTabValue} />
                </TabPanel>
                <TabPanel value={ECSubmissionTabValue} index={2}>
                  <ECNotification value={ECSubmissionTabValue} />
                </TabPanel>
                <TabPanel value={ECSubmissionTabValue} index={3}>
                  <ECAnnualReport value={ECSubmissionTabValue} />
                </TabPanel>
                <TabPanel value={ECSubmissionTabValue} index={4}>
                  <PvpdDetails />
                </TabPanel>
                <TabPanel value={ECSubmissionTabValue} index={5}>
                  <SaeTab />
                </TabPanel>
                <TabPanel value={ECSubmissionTabValue} index={6}>
                  <StudyClose />
                </TabPanel>
              </Box>
            </div>
          </Container>
        </>
      </Layout>
    </>
  );
};

export default EthicsCommittee;
